class AuthDVCService {
  /**
   * Kiểm tra phiên đăng nhập DVC còn không
   * dtnga3 (10.10.2022)
   */
  isDVCAuthenticated() {
    const tokenExpire = localStorage.getItem('DVCTokenExpire');
    if (tokenExpire) {
      var expire = new Date(tokenExpire);
      if (expire && expire > new Date()) {
        return true;
      }
    }
    return false;
  }
}

export default new AuthDVCService();
